import { addSalesType } from "../../../../../actions/Utilities/SalesType";
import { useMutation } from "react-query";

const useAddSalesType = () => {
  return useMutation(addSalesType);
};
export default useAddSalesType;
